import styled, { css } from 'styled-components';
import { FooterProps, GapProps, ContainerButtonProps } from './types';
import Row from '~components/dumbs/Row';

export const Footer = styled.footer<FooterProps>`
  display: flex;
  justify-content: ${({ $haveChildren }) =>
    $haveChildren ? 'space-between' : 'end'};
  border-top-color: ${({ theme }) => theme.color.border.neutral.default};
  border-top-style: ${({ theme }) => theme.border.style.solid};
  border-top-width: ${({ theme, $withDivider }) =>
    $withDivider ? theme.border.width.thinner : '0'};
  margin-left: -${({ theme, $marginSide }) => (!!$marginSide ? $marginSide : theme.spacing.km12)};
  margin-right: -${({ theme, $marginSide }) => (!!$marginSide ? $marginSide : theme.spacing.km12)};
  margin-top: ${({ $marginTop }) => $marginTop};
  padding-top: ${({ theme }) => theme.spacing.km8};
  padding-bottom: ${({ theme, $havePaddingBottom }) =>
    $havePaddingBottom ? theme.spacing.km8 : theme.spacing.km0};
  padding-left: ${({ theme }) => theme.spacing.km12};
  padding-right: ${({ theme }) => theme.spacing.km12};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding-top: ${({ theme }) => theme.spacing.km4};
    padding-left: ${({ theme }) => theme.spacing.km6};
    padding-right: ${({ theme }) => theme.spacing.km6};
    padding-bottom: ${({ theme, $havePaddingBottom, $havePaddingBottomSM }) =>
      $havePaddingBottom || $havePaddingBottomSM
        ? theme.spacing.km6
        : theme.spacing.km0};
    margin-left: -${({ theme }) => theme.spacing.km6};
    margin-right: -${({ theme }) => theme.spacing.km6};
    justify-content: space-between;
    ${({ $marginTopSM }) =>
      !!$marginTopSM &&
      css`
        margin-top: ${$marginTopSM};
      `};
    ${({ $isColumn }) =>
      $isColumn &&
      css<FooterProps>`
        flex-direction: column;
        padding-bottom: ${({
          theme,
          $havePaddingBottom,
          $havePaddingBottomSM,
        }) =>
          $havePaddingBottom || $havePaddingBottomSM
            ? theme.spacing.km6
            : theme.spacing.km0};
      `};
    ${({ $haveChildren }) =>
      $haveChildren &&
      css`
        padding-top: ${({ theme }) => theme.spacing.km8};
        padding-bottom: ${({ theme }) => theme.spacing.km6};
      `};
  }
`;

export const ContainerButton = styled(Row)<ContainerButtonProps>`
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    ${({ $isColumn }) =>
      $isColumn &&
      css`
        flex-direction: column-reverse;
      `};
  }
`;

export const Gap = styled.span<GapProps>`
  width: 25px;
  ${({ $isColumn }) =>
    $isColumn &&
    css`
      height: 25px;
    `}
`;
